<template>
  <transition tag="div" mode="out-in" appear enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div class="escola-parceira">
      <div id="header">
        <div class="img__header">
          <div class="bg__escuro"></div>
          <div class="bg__title">
            <b-container fluid="lg">
              <h2 class="text-title">Escola Parceira</h2>
            </b-container>
          </div>
        </div>
      </div>
      <Bread />
      <div class="container-lg container-fluid">
        <form class="mt-4" :class="{ 'was-validated': submitted }" @submit.prevent="handleSubmit">
          <div class="card shadow-sm p-4">
            <h1 class="display-5 text-center">Vamos trabalhar juntos?</h1>
            <p class="lead text-center">Preencha seus dados e em breve receba o contato de um especialista.</p>
            <hr class="border-light">
            <h3 class="h3">Dados da Escola</h3>
            <hr class="decorator">
            <div class="form-row no-gutters mt-4">
              <div class="col-12 col-md-6 col-lg-4 form-group">
                <label for="nomefantasia">Nome Fantasia <span class="text-danger">*</span></label>
                <span class="float-right"
                  v-b-tooltip.hover.top="'Como é reconhecida pelo público. Ex: Nome da marca ou nome de fachada.'">
                  <i class="fa-regular fa-circle-question"></i>
                </span>
                <input type="text" class="form-control" aria-invalid="false" required
                  aria-describedby="input-live-help input-live-feedback" v-model.trim="fantasia"
                  @blur="$v.fantasia.$touch()"
                  :class="{ 'is-invalid': $v.fantasia.$error, 'is-valid': !$v.fantasia.$invalid }" trim />
                <div :class="{ 'invalid-feedback': $v.fantasia.$error }" v-if="$v.fantasia.$error">
                  Campo obrigatório, não deixe vazio.
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 form-group">
                <label for="cnpj">CNPJ <span class="text-danger">*</span></label>
                <span class="float-right" v-b-tooltip.hover.top="'CNPJ (Cadastro Nacional de Pessoa Jurídica)'">
                  <i class="fa-regular fa-circle-question"></i>
                </span>
                <input type="text" class="form-control" :aria-invalid="!stateCnpj" required
                  aria-describedby="input-live-help input-live-feedback" v-model.trim="cnpj" @blur="$v.cnpj.$touch()"
                  :class="{ 'is-invalid': $v.cnpj.$error, 'is-valid': !$v.cnpj.$invalid }" trim
                  v-mask="'##.###.###/####-##'" />
                <div :class="{ 'invalid-feedback': $v.cnpj.$error }" v-if="$v.cnpj.$error">
                  Campo obrigatório, não deixe vazio.
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4 form-group">
                <label for="cnpj">Rede de Origem <span class="text-danger">*</span></label>
                <select class="custom-select" required @blur="$v.redeEscolar.$touch()" v-model="redeEscolar"
                  :class="{ 'is-invalid': $v.redeEscolar.$error, 'is-valid': !$v.redeEscolar.$invalid }">
                  <option disabled>Selecione uma opção</option>
                  <option v-for="escola in listRedeEscolar" :key="escola.id" :value="escola.value">{{ escola.text }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="$v.redeEscolar.$error || redeEscolar === ''">
                  Campo obrigatório, não deixe vazio.
                </div>
              </div>
              <div class="col-12 col-md-3 col-lg-2 form-group">
                <label for="numalunos">Nº de Alunos <span class="text-danger">*</span></label>
                <span class="float-right" v-b-tooltip.hover.top="'Quantidade de alunos matrículados na escola.'">
                  <i class="fa-regular fa-circle-question"></i>
                </span>
                <input type="text" class="form-control" aria-invalid="false" required
                  aria-describedby="input-live-help input-live-feedback" v-model.trim="numAluno"
                  @blur="$v.numAluno.$touch()"
                  :class="{ 'is-invalid': $v.numAluno.$error, 'is-valid': !$v.numAluno.$invalid }" trim />
                <div :class="{ 'invalid-feedback': $v.numAluno.$error }" v-if="$v.numAluno.$error">
                  Campo obrigatório
                </div>
              </div>
              <div class="col-12 col-md-5 col-lg-4 form-group">
                <label for="materialutilizado">Qual material é utilizado? <span class="text-danger">*</span></label>
                <span class="float-right" v-b-tooltip.hover.top="'Material utilizado na didática do ensino'">
                  <i class="fa-regular fa-circle-question"></i>
                </span>
                <select class="custom-select" required @blur="$v.materialUtilizado.$touch()" v-model="materialUtilizado"
                  :class="{ 'is-invalid': $v.materialUtilizado.$error, 'is-valid': !$v.materialUtilizado.$invalid }">
                  <option disabled>Selecione uma opção</option>
                  <option v-for="material in materialUtilizadoAtualmente.data" :key="material.id"
                    :value="material.material">{{
                      material.material }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="$v.materialUtilizado.$error || materialUtilizado === ''">
                  Campo obrigatório, não deixe vazio.
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 form-group">
                <label for="estado">Estado <span class="text-danger">*</span></label>
                <select class="custom-select" required @blur="$v.estado.$touch()" v-model="estado"
                  :class="{ 'is-invalid': $v.estado.$error, 'is-valid': !$v.estado.$invalid }">
                  <option disabled>Selecione uma opção</option>
                  <option v-for="estado in estadosBrasileiros.geonames" :key="estado.id" :value="estado.UF">{{
                    estado.name }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="$v.estado.$error || estado === ''">
                  Campo obrigatório, não deixe vazio.
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 form-group">
                <label for="estado">Cidade <span class="text-danger">*</span></label>
                <span class="float-right"
                  v-b-tooltip.hover.top="'Selecione o campo Estado, para depois selecionar o campo Cidade'">
                  <i class="fa-regular fa-circle-question"></i>
                </span>
                <select class="custom-select" required @blur="$v.cidade.$touch()" v-model="cidade"
                  :class="{ 'is-invalid': $v.cidade.$error, 'is-valid': !$v.cidade.$invalid }" :disabled="!estado">
                  <option disabled>Selecione uma opção</option>
                  <option v-for="cidade in filteredCidades" :key="cidade.id" :value="cidade.cidade">{{
                    cidade.cidade }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="$v.cidade.$error || cidade === ''">
                  Campo obrigatório, não deixe vazio.
                </div>
              </div>
            </div>
          </div>
          <div class=" card shadow-sm p-3 mt-2">
            <h3 class="h3">Dados Pessoais</h3>
            <hr class="decorator">
            <div class="form-row no-gutters mt-4">
              <div class="col-12 col-md-6 col-lg-4 form-group">
                <label for="nomecompleto">Nome Completo <span class="text-danger">*</span></label>
                <span class="float-right" v-b-tooltip.hover.top="'Quantidade de alunos matrículados na escola.'">
                  <i class="fa-regular fa-circle-question"></i>
                </span>
                <input type="text" class="form-control" aria-invalid="false" required
                  aria-describedby="input-live-help input-live-feedback" v-model.trim="nomeCompleto"
                  @blur="$v.nomeCompleto.$touch()"
                  :class="{ 'is-invalid': $v.nomeCompleto.$error, 'is-valid': !$v.nomeCompleto.$invalid }" trim />
                <div :class="{ 'invalid-feedback': $v.nomeCompleto.$error }" v-if="$v.nomeCompleto.$error">
                  Campo obrigatório, não deixe vazio
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 form-group">
                <label for="email">E-mail <span class="text-danger">*</span></label>
                <span class="float-right" v-b-tooltip.hover.top="'Quantidade de alunos matrículados na escola.'">
                  <i class="fa-regular fa-circle-question"></i>
                </span>
                <input type="email" class="form-control" aria-invalid="false" required
                  aria-describedby="input-live-help input-live-feedback" v-model.trim="email" @blur="$v.email.$touch()"
                  :class="{ 'is-invalid': $v.email.$error, 'is-valid': !$v.email.$invalid }" :formatter="formatterEmail"
                  trim />
                <div :class="{ 'invalid-feedback': $v.email.$error }"
                  v-if="$v.email.$error == true && $v.email.email == true && email == ''">
                  Campo obrigatório, não deixe vazio
                </div>
                <div :class="{ 'invalid-feedback': $v.email.$error }"
                  v-if="$v.email.$error == true && !$v.email.email && email != ''">
                  O campo precisa ser um formato valido
                </div>
              </div>
              <div class="col-12 col-md-5 col-lg-4 form-group">
                <label for="telefonecelular">Telefone/Celular <span class="text-danger">*</span></label>
                <span class="float-right" v-b-tooltip.hover.top="'Nº de Telefone ou Celular'">
                  <i class="fa-regular fa-circle-question"></i>
                </span>
                <input type="text" class="form-control" aria-invalid="false" required
                  aria-describedby="input-live-help input-live-feedback" v-model.trim="telefone"
                  @blur="$v.telefone.$touch()"
                  :class="{ 'is-invalid': $v.telefone.$error, 'is-valid': !$v.telefone.$invalid }"
                  v-mask="formatTelephone" trim />
                <div :class="{ 'invalid-feedback': $v.telefone.$error }" v-if="$v.telefone.$error">
                  Campo obrigatório, não deixe vazio
                </div>
              </div>
            </div>
          </div>
          <div class="card shadow-sm p-3 mt-2">
            <div class="form-row no-gutters">
              <div class="col-12 col-md-6 col-lg-6">
                <h3 class="h3">Como conheceu?</h3>
                <hr class="decorator">
                <div class="mt-4">
                  <div class="custom-control custom-checkbox mb-2" v-for="option in comoConheceu.data" :key="option.id">
                    <input type="checkbox" class="custom-control-input" :id="option.conheceu + option.id"
                      :aria-invalid="!checkboxOConheceu" @blur="$v.oConheceu.$touch()"
                      :class="{ 'is-invalid': $v.oConheceu.$error, 'is-valid': !$v.oConheceu.$invalid }"
                      v-model="oConheceu" :value="option.conheceu">
                    <label class="custom-control-label" :for="option.conheceu + option.id">{{ option.conheceu
                      }}</label>
                  </div>
                  <div :class="{ 'invalid-feedback': $v.oConheceu.$error }" v-if="$v.oConheceu.$error">Campo
                    Obrigatório, selecione uma ou mais opções </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6">
                <h3 class="h3">Qual material de interesse?</h3>
                <hr class="decorator">
                <div class="mt-4">
                  <div class="custom-control custom-checkbox mb-2" v-for="option in materialInteresse.data"
                    :key="option.id">
                    <input type="checkbox" class="custom-control-input" :id="option.interesse + option.id"
                      :aria-invalid="!checkboxOInteresse" @blur="$v.oInteresse.$touch()"
                      :class="{ 'is-invalid': $v.oInteresse.$error, 'is-valid': !$v.oInteresse.$invalid }"
                      v-model="oInteresse" :value="option.interesse">
                    <label class="custom-control-label" :for="option.interesse + option.id">{{ option.interesse
                      }}</label>
                  </div>
                  <div :class="{ 'invalid-feedback': $v.oInteresse.$error }" v-if="$v.oInteresse.$error">Example
                    invalid feedback text</div>
                </div>
              </div>
              <hr class="border-light">
              <div class="col-12">
                <button type="submit" class="btn btn-send float-right" v-if="!spin">Enviar</button>
                <div class="d-flex align-items-center justify-content-center">
                  <div class="spinner-grow" role="status" v-if="spin === true">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>
<script>
import ApiService from '@/common/api.service';
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';
import { cnpj } from 'cpf-cnpj-validator';

import materialUtilizadoAtualmente from '@/components/data/materialUtilizado.json';
import materialInteresse from '@/components/data/materialInteresse.json';
import cidadesEstadosBrasileiros from '@/components/data/cidade.json'
import estadosBrasileiros from '@/components/data/estados.json'
import comoConheceu from '@/components/data/comoConheceu.json';

export default {
  name: 'formEscolaParceira',
  metaInfo: { title: 'Escola Parceira' },
  components: { Bread: () => import('../../GlobalComponents/bread-sistema.vue') },
  data: function () {
    return {
      escolaParceira: {
        data: [],
      },

      spin: false,

      /* Dados da Escola */
      fantasia: '',
      cnpj: '',
      redeEscolar: '',
      numAluno: '',
      materialUtilizado: '',
      estado: '',
      cidade: '',
      listRedeEscolar: [
        { id: 0, value: 'Escola Privada', text: 'Escola Privada' },
        { id: 1, value: 'Escola Federal', text: 'Escola Federal' },
        { id: 2, value: 'Escola Pública', text: 'Escola Pública' },
        { id: 3, value: 'Escola Estadual', text: 'Escola Estadual' },
        { id: 4, value: 'Fundação', text: 'Fundação' },
        { id: 5, value: 'ONG', text: 'ONG' },
      ],

      /* Dados Pessoais */
      nomeCompleto: '',
      email: '',
      telefone: '',
      erroTelefone: false,

      /* Checkbox Conheceu e Material */
      oConheceu: [],
      oInteresse: [],

      submitted: false,


      materialUtilizadoAtualmente,
      cidadesEstadosBrasileiros,
      estadosBrasileiros,
      materialInteresse,
      comoConheceu,
    }
  },
  validations: {
    // Dado Escolar
    fantasia: { required, minLength: minLength(5), maxLength: maxLength(100) },
    cnpj: { required, minLength: minLength(18), maxLength: maxLength(18) },
    redeEscolar: { required },
    numAluno: { required },
    materialUtilizado: { required },
    estado: { required },
    cidade: { required },

    // Dados Pessoais
    nomeCompleto: { required },
    email: { required, email },
    telefone: { required, minLength: minLength(14), maxLength: maxLength(15) },

    // Check Conheceu e Material
    oConheceu: { required },
    oInteresse: { required }
  },
  computed: {
    // Dados Escolares
    stateFantasia() {
      if (!this.fantasia) return null;
      if (this.$v.fantasia.$pending) return null;

      return !this.$v.fantasia.$error;
    },
    stateCnpj() {
      if (!this.cnpj) return null;
      if (this.$v.cnpj.$pending) return null;

      return !this.$v.cnpj.$error
    },
    checkCnpj() {
      return cnpj.isValid(this.cnpj)
    },
    stateRedeOrigem() {
      if (!this.redeEscolar) return null;
      if (this.$v.redeEscolar.$pending) return null;

      return !this.$v.redeEscolar.$error
    },
    stateNumAluno() {
      if (!this.numAluno) return null;
      if (this.numAluno.$pending) return null;

      return !this.$v.numAluno.$error;
    },
    stateMaterialUtilizado() {
      if (!this.materialUtilizado) return null;
      if (this.materialUtilizado.$pending) return null;

      return !this.$v.materialUtilizado.$error;
    },
    filteredCidades() {
      if (!this.estado) return [];
      return this.cidadesEstadosBrasileiros.data.filter((cidade) => {
        return cidade.estado === this.estado
      })
    },

    // Dados Pessoais
    stateNome() {
      if (!this.nomeCompleto) return null;
      if (this.$v.nomeCompleto.$pending) return null;

      return !this.$v.nomeCompleto.$error && this.nomeCompleto.length > 5;
    },
    stateEmail() {
      if (!this.email) return null;
      if (this.$v.email.$pending) return null;

      return !this.$v.email.$error;
    },
    stateTelefone() {
      if (!this.telefone) return null;
      if (this.$v.telefone.$pending) return null;

      return !this.$v.telefone.$error
    },

    formatTelephone() {
      return this.telefone.length > 14 ? '(##) #####-####' : '(##) ####-####'
    },

    // Check Conheceu e Material 
    checkboxOConheceu() {
      if (!this.oConheceu) return null;
      if (this.$v.oConheceu.$pending) return null;

      return !this.$v.oConheceu.$error
    },
    checkboxOInteresse() {
      if (!this.oInteresse) return null;
      if (this.$v.oInteresse.$pending) return null;

      return !this.$v.oInteresse.$error
    }
  },
  methods: {
    postMessage() {
      const formContact = {
        fantasia: this.fantasia,
        cnpj: this.cnpj,
        redeEscolar: this.redeEscolar,
        numAluno: this.numAluno,
        materialUtilizado: this.materialUtilizado,
        estado: this.estado,
        cidade: this.cidade,
        nomeCompleto: this.nomeCompleto,
        email: this.email,
        telefone: this.telefone,
        oConheceu: this.oConheceu,
        oInteresse: this.oInteresse
      }

      ApiService.post('/v1/escola-parceira', formContact)
        .then((response) => {
          this.spin = false

          this.escolaParceira = response;
          let nome = this.nomeCompleto;

          if (typeof nome === 'string' && nome.trim() !== '') {
            nome = nome.split(' ')[0];
          } else {
            nome = '';
          }

          this.$router.push({ name: 'thanks', params: { nome: nome } });
        })
        .catch((error) => {
          console.log('Ops...', error)
        })
        .finally(() => {
          this.spin = false
        });
    },
    handleSubmit() {
      this.spin = true;
      this.submitted = true;
      this.$v.$touch();

      let validation = this.$v.$invalid;
      let isValidCnpj = this.checkCnpj;

      if (validation || isValidCnpj === false) {
        setTimeout(() => {
          this.spin = false;
        }, 2000)
        return;
      }

      this.postMessage();
    },
    formatterEmail(value) {
      return value.toLowerCase()
    },
    validTelephone() {
      const regex = /^\(\d{2}\) \d{4,5}-\d{4}$/;
      this.errorTelephone = !regex.test(this.telefone);
    },
    clearReturnoEstado() {
      return (this.cidade = '');
    }
  }
}
</script>
<style lang="scss" scoped>
.escola-parceira {
  background-color: #f6f6f6;
  padding: 0 0 30px;

  #header {
    position: relative;

    .img__header {
      position: absolute;
      display: block;
      background-image: url('https://sitecpv.s3.amazonaws.com/Images/escola_parceira-1920x1282.jpg');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }
  }

  form {
    .card {
      border-radius: 12px;

      h1.display-5 {
        font-size: 2.5rem;
        font-weight: 300;
        color: #333;
      }

      p.lead {
        font-size: 1.25rem;
        font-weight: 300;
        color: #333;
      }

      hr.border-light {
        width: 100%;
        border-top: 1px solid #d0d0d0;
      }

      hr.decorator {
        margin: 0;
        border: 3px solid #F8DBBB;
        max-width: 50px;
        border-radius: 8px;
      }

      button {
        margin: 0;
        padding: 0;
        background: none;
        border: none;
        color: #333;
        cursor: pointer;
      }


      .form-group {
        label {
          margin: 0;
          font-size: 0.875rem;
          font-weight: 500;
          color: #333;
        }

        .invalid-feedback {
          font-size: 0.75rem;
          font-style: italic;
          font-weight: 300;
          line-height: 20px;
          letter-spacing: 0%;
        }
      }

      .btn-send {
        padding: 8px 16px;
        background-color: orange;
        color: #333;
        border: 1px solid;
        border-color: orange;
        border-radius: 8px;

        font-size: .875rem;
        font-weight: 600;
        text-transform: uppercase;

        line-height: 22px;
        letter-spacing: 0%;


        &:hover {
          background-color: rgb(226, 148, 2);
          transition: all .5s ease;
          box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }

}
</style>